import { useEffect, useRef } from 'react';

const setMetaTag = (attr, key, value) => {
  if (!value) return;
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', value);
};

const setLinkTag = (rel, href) => {
  if (!href) return;
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

export default function WebsiteMeta({ title, description, image, favicon }) {
  const prevTitle = useRef('');
  const prevFavicon = useRef('');

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    prevTitle.current = document.title;
    if (title) {
      document.title = title;
    }

    if (description) {
      setMetaTag('name', 'description', description);
    }
    if (title) {
      setMetaTag('property', 'og:title', title);
      setMetaTag('name', 'twitter:title', title);
    }
    if (description) {
      setMetaTag('property', 'og:description', description);
      setMetaTag('name', 'twitter:description', description);
    }
    if (image) {
      setMetaTag('property', 'og:image', image);
      setMetaTag('name', 'twitter:image', image);
      setMetaTag('name', 'twitter:card', 'summary_large_image');
    }

    if (favicon) {
      const currentIcon = document.querySelector('link[rel="icon"]');
      prevFavicon.current = currentIcon ? currentIcon.getAttribute('href') || '' : '';
      setLinkTag('icon', favicon);
      setLinkTag('shortcut icon', favicon);
      setLinkTag('apple-touch-icon', favicon);
    }

    return () => {
      if (prevTitle.current) {
        document.title = prevTitle.current;
      }
      if (favicon && prevFavicon.current) {
        setLinkTag('icon', prevFavicon.current);
        setLinkTag('shortcut icon', prevFavicon.current);
        setLinkTag('apple-touch-icon', prevFavicon.current);
      }
    };
  }, [title, description, image, favicon]);

  return null;
}
